import {observer} from "mobx-react";
import {FieldInput, FieldSelect, FormSection} from "../../ui";
import {SalutationTypeDto, UserGroupTypeDto} from "../../../api/ums";
import {displaySalutation, displayUserGroup} from "../../../api";
import {validationStore} from "../../../store"

export interface FormData {
    group: UserGroupTypeDto | null
    salutation: SalutationTypeDto | null
    firstname: string
    lastname: string
    username?: string
    keycloakId?: string
    email: string
    remark: string
    phoneNumber: string
}

interface UserFormProps {
    data: FormData
    onValidate: () => any
    onChange: (data: FormData) => any
    visibleUsername?: boolean
    visibleKeycloakId?: boolean
    saving: boolean
}

const groupOptions = Object.keys(UserGroupTypeDto).map(v => ({
    value: v,
    label: displayUserGroup(v as UserGroupTypeDto)
}))

const salutationOptions = Object.keys(SalutationTypeDto).map(v => ({
    value: v,
    label: displaySalutation(v as SalutationTypeDto)
}))

const UserForm = observer(function UserForm({
                                                data,
                                                onChange,
                                                onValidate,
                                                visibleUsername,
                                                visibleKeycloakId,
                                                saving
                                            }: UserFormProps) {
    const salutationHelp = validationStore.getFor('salutation')
    const firstnameHelp = validationStore.getFor('firstname')
    const lastnameHelp = validationStore.getFor('lastname')
    const emailHelp = validationStore.getFor('email')
    const phoneNumberHelp = validationStore.getFor('phoneNumber')
    const remarkHelp = validationStore.getFor('remark')
    const groupHelp = validationStore.getFor('group')

    return <div style={{flex: '1', overflow: 'auto', padding: '1em'}}>
        <FormSection
            label={"Allgemeines"}
            children={
                <>
                    <div className="columns">
                        <div className="column is-one-third">
                            <FieldSelect
                                disabled={saving}
                                label={"Benutzer-Gruppe"}
                                options={groupOptions}
                                help={groupHelp}
                                invalid={Boolean(groupHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    group: v as UserGroupTypeDto || null
                                })}
                                value={data.group || ''}
                            />
                        </div>
                        {visibleUsername && <div className="column is-one-third">
                            <FieldInput
                                disabled={true}
                                label={"Benutzername"}
                                value={data.username || ''}
                            />
                        </div>}
                        {visibleKeycloakId && <div className="column is-one-third">
                            <FieldInput
                                disabled={true}
                                label={"Keycloak-Id"}
                                value={data.keycloakId || ''}
                            />
                        </div>}
                    </div>
                    <div className="columns">
                        <div className="column is-one-third">
                            <FieldSelect
                                disabled={saving}
                                label={"Anrede"}
                                options={salutationOptions}
                                help={salutationHelp}
                                invalid={Boolean(salutationHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    salutation: v as SalutationTypeDto || null
                                })}
                                value={data.salutation || ''}
                            />
                        </div>
                        <div className="column is-one-third">
                            <FieldInput
                                disabled={saving}
                                label={"Vorname"}
                                help={firstnameHelp}
                                invalid={Boolean(firstnameHelp)}
                                onBlur={() => onValidate()}
                                value={data.firstname}
                                onChange={v => onChange({
                                    ...data,
                                    firstname: v
                                })}
                            />
                        </div>
                        <div className="column is-one-third">
                            <FieldInput
                                disabled={saving}
                                label={"Nachname"}
                                value={data.lastname}
                                help={lastnameHelp}
                                invalid={Boolean(lastnameHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    lastname: v
                                })}
                            />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-two-third">
                            <FieldInput
                                disabled={saving}
                                label={"E-Mail"}
                                value={data.email}
                                help={emailHelp}
                                invalid={Boolean(emailHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    email: v
                                })}
                            />
                        </div>
                        <div className="column is-one-third">
                            <FieldInput
                                disabled={saving}
                                label={"Telefonnummer"}
                                value={data.phoneNumber}
                                help={phoneNumberHelp}
                                invalid={Boolean(phoneNumberHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    phoneNumber: v
                                })}
                            />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column">
                            <FieldInput
                                disabled={saving}
                                label={"Bemerkung"}
                                value={data.remark}
                                help={remarkHelp}
                                invalid={Boolean(remarkHelp)}
                                onBlur={() => onValidate()}
                                onChange={v => onChange({
                                    ...data,
                                    remark: v
                                })}
                            />
                        </div>
                    </div>
                </>
            }
        />
    </div>
})

export {
    UserForm
}
